<script>
import {defineComponent} from 'vue';
import {useI18n} from 'vue-i18n';
import OrderForm from "@/components/forms/OrderForm.vue";
import $http from "@/axios.config";
import Swal from "sweetalert2";
import LogsTable from "@/components/admin-page/LogsTable.vue";
import ChatPage from "@/components/order-chat/ChatPage.vue";
import {log} from "@/utils/clientLogger.js";

export default defineComponent({
  name: "OrderPage",
  components: {LogsTable, OrderForm, ChatPage},
  data() {
    return {
      orderData: {},
      logs: []
    };
  },
  setup() {
    const {t} = useI18n();
    return {t};
  },
  methods: {
    fetchLogs() {
      this.$http.get("/api/logs/order/" + this.$route.params.id).then((res) => {
        this.logs = res.data;
      }).catch((err) => {
        log.error('View:OrderPage:fetchLogs', {'error': err});
      });
    },
    sendOrder(data) {
      $http.put('/api/orders/' + data._id, data).then(() => {
        Swal.fire({
          icon: 'success',
          title: this.t('alerts.success'),
          text: this.t('messages.orderUpdated'),
        });
        this.$router.push('/');
      }).catch((err) => {
        log.error('View:OrderPage:sendOrder', {'error': err});
        Swal.fire({
          icon: 'error',
          title: this.t('alerts.error'),
          text: err.response?.data?.message || this.t('messages.error'),
        });
      }).finally(() => {
        this.$refs.orderFormRef?.submissionComplete();
      });
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchLogs();
  }
});
</script>

<template>
  <div class="row mt-4">
    <div class="col-md-6 order-form-col">
      <OrderForm ref="orderFormRef" :order-id="$route.params.id" @submitOrder="sendOrder" @orderLoaded="orderData = $event" @cutsLogged="fetchLogs"/>
    </div>

    <div class="col-md-6">
      <div class="chat-pane">
        <ChatPage :order-id="$route.params.id"/>
      </div>
    </div>

    <div class="col-12 mt-4">
      <h3>{{ t('labels.changeHistory') }}</h3>
      <LogsTable v-if="logs" :logs="logs" :human-id="orderData.humanId" :car-info="`${orderData.carBrand || ''} ${orderData.carModel || ''} ${orderData.carYear || ''}`.trim()"/>
    </div>
  </div>
</template>

<style lang="scss">
.fancybox__container {
  z-index: 1500 !important;
}

@media (min-width: 768px) {
  .chat-pane {
    position: sticky;
    top: 1rem;
  }
}
</style>